import React from 'react';
import { AlertTriangle } from 'lucide-react';

export function ClientInfoCard({
  clientName,
  setClientName,
  currentProvider,
  setCurrentProvider,
  preparedBy,
  setPreparedBy,
  quoteDate,
  setQuoteDate,
  isAdp,
  adpUnbundled,
  setAdpUnbundled,
}) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm" data-testid="client-info-card">
      <h2 className="text-lg font-semibold font-['Outfit'] text-slate-900 mb-4">Client Information</h2>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div>
          <label className="block text-xs font-medium text-slate-500 uppercase tracking-wider mb-1.5">
            Client Name
          </label>
          <input
            data-testid="client-name-input"
            value={clientName}
            onChange={e => setClientName(e.target.value)}
            placeholder="Enter client name"
            className="w-full h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#3c68ff] focus:ring-offset-1"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-500 uppercase tracking-wider mb-1.5">
            Current Provider
          </label>
          <select
            data-testid="current-provider-select"
            value={currentProvider}
            onChange={e => setCurrentProvider(e.target.value)}
            className="w-full h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#3c68ff] focus:ring-offset-1"
          >
            <option value="">Select provider...</option>
            <option>ADP TotalSource</option>
            <option>Oasis / Paychex</option>
            <option>TriNet</option>
            <option>Insperity</option>
            <option>Justworks</option>
            <option>Other</option>
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-500 uppercase tracking-wider mb-1.5">
            Prepared By
          </label>
          <input
            data-testid="prepared-by-input"
            value={preparedBy}
            onChange={e => setPreparedBy(e.target.value)}
            placeholder="Your name"
            className="w-full h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#3c68ff] focus:ring-offset-1"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-slate-500 uppercase tracking-wider mb-1.5">
            Quote Date
          </label>
          <input
            data-testid="quote-date-input"
            type="date"
            value={quoteDate}
            onChange={e => setQuoteDate(e.target.value)}
            className="w-full h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#3c68ff] focus:ring-offset-1"
          />
        </div>
      </div>
      {isAdp && (
        <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg flex items-center gap-3">
          <AlertTriangle size={16} className="text-amber-500" />
          <label className="flex items-center gap-2 text-sm text-amber-800 cursor-pointer">
            <input
              data-testid="adp-unbundled-checkbox"
              type="checkbox"
              checked={adpUnbundled}
              onChange={e => setAdpUnbundled(e.target.checked)}
              className="rounded border-amber-300 text-amber-500 focus:ring-amber-400"
            />
            Unbundled Rates — Enter separate Service Fee % per state/class code (default is bundled: WC Rate
            includes Service Fee)
          </label>
        </div>
      )}
    </div>
  );
}
